(function () {
  "use strict";

  var gatewayUrl = "https://pulsesensor.com/pages/agent-research-gateway-v1-test";
  window.PulseSensorAgentDiscovery = Object.freeze({
    kind: "browser-webmcp",
    gateway: gatewayUrl,
    catalogVersion: "1.0.0",
    privacy: "read-only; no personal or live PPG data; no purchases or account actions",
    browserRequirement: "document.modelContext.registerTool"
  });

  if (window.location.pathname !== "/pages/agent-research-gateway-v1-test") return;

  var attempts = 0;
  var register = window.setInterval(async function () {
    attempts += 1;
    var api = window.PulseSensorResearchGateway;
    var context = document.modelContext || navigator.modelContext;
    if (api && api.enabled && Array.isArray(api.tools) && context && typeof context.registerTool === "function") {
      window.clearInterval(register);
      if (window.PulseSensorResearchGatewayAbortController) return;
      var controller = new AbortController();
      window.PulseSensorResearchGatewayAbortController = controller;
      for (var i = 0; i < api.tools.length; i += 1) {
        try {
          await context.registerTool(api.tools[i], { signal: controller.signal });
        } catch (error) {
          console.warn("PulseSensor WebMCP tool registration failed", api.tools[i].name, error);
        }
      }
    } else if (attempts >= 100) {
      window.clearInterval(register);
    }
  }, 100);
})();
